import React from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button } from 'antd'
import { FormOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'

const columns = () => [
  {
    width: 120,
    title: t('Admin.TeleconsultingCompanyList.table.name'),
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name)
  },
  {
    width: 170,
    title: t('Admin.TeleconsultingCompanyList.table.url'),
    dataIndex: 'url',
    key: 'url',
    sorter: (a, b) => a.url.localeCompare(b.url)
  },
  {
    width: 50,
    title: t('Admin.TeleconsultingCompanyList.table.minimum_age'),
    dataIndex: 'minimum_age',
    key: 'minimum_age'
  },
  {
    width: 100,
    title: t('Admin.TeleconsultingCompanyList.table.increased_slot_duration'),
    dataIndex: 'increased_slot_duration',
    key: 'increasedWaitingTime',
    render: (value) => value ? 'Oui' : 'Non'
  },
  {
    width: 50,
    key: 'action',
    render: (_, o) => <>
      <Link to={`/admin/teleconsulting_companies/${o.id}`}><Button shape="circle" icon={<FormOutlined />} /></Link>
    </>
  }
]

export default function TeleconsultingCompaniesList ({ teleconsultingCompanies }) {
  return (
    <CustTable
      height={700}
      initColumns={columns()}
      dataSource={teleconsultingCompanies}
    />
  )
}
